export const ALL_TAGS = "ALL_TAGS";
export const ALL_TAGS_SUCCESS = "ALL_TAGS_SUCCESS";
export const ALL_TAGS_FAIL = "ALL_TAGS_FAIL";
